/**
 * @fileoverview This file implements an agentic loop that uses an LLM to choose and execute tools based on user input and previous tool outputs. It continues until the 'finish' tool is called.
 */

import { Message } from '@iterator/shared-node/ai/llm_types'
import { callChatCompletionsForToolCalls } from './ai/llm_api'
import { doCall } from './tools/all_tools'
import { exit_with_error, print_ai, print_ai_block } from '@iterator/shared-node/util/logging'
import { ClaudeSonnetModel } from './ai/models'

const SYSTEM_PROMPT = `You are an AI agent tasked with helping users accomplish their goals.
Start by writing a bulleted list of steps you need to take to accomplish the user's goal.
Explain each step and note any information you need to gather.
When you're ready to take a step, first explain what you're doing and why. 
Then choose the most appropriate tool for each step.`

const DEFAULT_MAX_ITERATIONS = 15

export async function runAgentLoop(
  initialPrompt: string,
  maxIterations: number = DEFAULT_MAX_ITERATIONS,
) {
  const conversation: Message[] = [
    { role: 'system', content: SYSTEM_PROMPT },
    { role: 'user', content: initialPrompt },
  ]

  let iteration = 0
  while (true) {
    const response = await callChatCompletionsForToolCalls(
      SYSTEM_PROMPT,
      [],
      conversation,
      ClaudeSonnetModel,
    )
    print_ai(response.message.content)
    print_ai_block('tools', response.toolCalls)
    conversation.push(response.message)

    const toolCalls = response.toolCalls
    if (!toolCalls.length) {
      continue
    }

    for (const toolCall of toolCalls) {
      const callResponse = await doCall(toolCall)
      conversation.push({
        role: 'assistant',
        content: callResponse,
      })
    }
    conversation.push({
      role: 'user',
      content:
        "If you're done go ahead and finish. Otherwise keep going and explain what you're doing.",
    })

    iteration++
    if (iteration > maxIterations) {
      exit_with_error(`Max iterations (${maxIterations}) reached.`)
    }
  }
}
